var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateCw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.166 3.33301V8.33301H14.166",
    stroke: "#56585A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0756 12.5003C16.5339 14.0336 15.5085 15.3493 14.154 16.2491C12.7995 17.1489 11.1893 17.5841 9.5659 17.4892C7.94254 17.3942 6.39401 16.7742 5.15368 15.7226C3.91335 14.6709 3.0484 13.2447 2.68919 11.6587C2.32997 10.0727 2.49595 8.41299 3.1621 6.92956C3.82826 5.44613 4.9585 4.21939 6.38251 3.4342C7.80653 2.64902 9.44716 2.34792 11.0572 2.57629C12.6672 2.80466 14.1594 3.55012 15.3089 4.70034L19.1672 8.33367",
    stroke: "#56585A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateCw);
export default __webpack_public_path__ + "static/media/rotate-cw.72d66c9f7670d90b8b8d1523fa06dd76.svg";
export { ForwardRef as ReactComponent };